import 'swiper/css';
import 'swiper/css/virtual';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import testimonials from '../mocks/testimonials.json';
import Testimonial, { TestimonialProps } from '../components/Testimonial';
import { Autoplay, Pagination, Virtual } from 'swiper/modules';
import ReactPlayer from 'react-player';
import { Link } from 'react-router-dom';

const Home = () => {
    return (
        <>
            <section id='hero' className='hero'>
                <div className='container'>
                    <div className='row gy-4'>
                        <div
                            className='col-lg-8 text-center text-lg-start order-2 order-lg-1 d-flex flex-column justify-content-center'
                            data-aos='zoom-out'
                        >
                            <h1>La community fashion</h1>
                            <h2 className='h4'>
                                Presentatevi al mondo della moda con <br />
                                <label>Glami Inside Fashion</label>!
                            </h2>
                            <div>
                                <Link to='/contact' className='btn-get-started mt-3'>
                                    Contattaci
                                </Link>
                            </div>
                        </div>
                        <div
                            className='col-lg-4 text-center text-lg-start order-1 order-lg-2 d-flex justify-content-center'
                            data-aos='zoom-out'
                        >
                            <ReactPlayer
                                url='img/video.webm'
                                playing
                                muted
                                loop
                                playsinline
                                controls={false}
                                height='30rem'
                                width='100%'
                                config={{
                                    file: {
                                        attributes: {
                                            preload: 'auto',
                                            playsInline: true,
                                            muted: true,
                                        },
                                    },
                                }}
                            />
                        </div>
                    </div>
                </div>
            </section>

            <section id='about' className='about'>
                <div className='container section-title' data-aos='fade-up'>
                    <h2>Chi siamo</h2>
                </div>

                <div className='container'>
                    <div className='row gy-4'>
                        <div className='col-lg-6 content text-center' data-aos='fade-up' data-aos-delay='100'>
                            <img src={'img/about.webp'} width='380px' className='img-fluid' alt='Alessandra e Ludovica' />
                        </div>

                        <div className='col-lg-6' data-aos='fade-up' data-aos-delay='200'>
                            <p>
                                <strong>Glami Inside Fashion</strong> è la community che mette in contatto professionisti e studenti del
                                settore moda, creando connessioni, collaborazioni e opportunità di lavoro.
                            </p>
                            <p>Il progetto si divide in due aree:</p>
                            <ul>
                                <li>
                                    <i className='bi bi-check2-circle'></i>
                                    <span>
                                        La parte formativa, riservata agli studenti di moda, si impegna a far vivere loro una reale
                                        esperienza sul campo, fornendo una overview su tutti i settori e le professioni esistenti nel
                                        fashion system.
                                    </span>
                                </li>
                                <li>
                                    <i className='bi bi-check2-circle'></i>
                                    <span>
                                        La parte di servizi per le aziende e per i professionisti che si occupa di ricerca, recruiting e
                                        casting. Servizio di consulenza e avviamento carriera. Servizio di backstage styling e coordinamento
                                        per gli eventi di moda.
                                    </span>
                                </li>
                            </ul>
                            <Link to='/contact' className='read-more mt-3'>
                                <span>Contattaci</span>
                                <i className='bi bi-arrow-right'></i>
                            </Link>
                        </div>
                    </div>
                </div>
            </section>

            <section id='cosa-offriamo' className='services dark'>
                <div className='container section-title-dark' data-aos='fade-up'>
                    <h2>Cosa offriamo</h2>
                </div>

                <div className='container'>
                    <div className='row gy-4'>
                        <div className='col-xl-4 col-md-6 d-flex' data-aos='fade-up' data-aos-delay='100'>
                            <div className='service-item-dark'>
                                <h4>
                                    <Link to='/training' className='stretched-link'>
                                        FORMAZIONE
                                    </Link>
                                </h4>
                                <img src={'img/services/formazione.webp'} className='img-fluid' alt='FORMAZIONE' />
                            </div>
                        </div>

                        <div className='col-xl-4 col-md-6 d-flex' data-aos='fade-up' data-aos-delay='200'>
                            <div className='service-item-dark'>
                                <h4>
                                    <Link to='/services' className='stretched-link'>
                                        STYLING TEAM AND BACKSTAGE COORDINATION
                                    </Link>
                                </h4>
                                <img
                                    src={'img/services/stylist.webp'}
                                    className='img-fluid'
                                    alt='STYLING TEAM AND BACKSTAGE COORDINATION'
                                />
                            </div>
                        </div>

                        <div className='col-xl-4 col-md-6 d-flex' data-aos='fade-up' data-aos-delay='300'>
                            <div className='service-item-dark'>
                                <h4>
                                    <Link to='/services' className='stretched-link'>
                                        SERVIZI DI CONSULENZA
                                    </Link>
                                </h4>
                                <img src={'img/services/consulenza.webp'} className='img-fluid' alt='SERVIZI DI CONSULENZA' />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id='showcase' className='call-to-action'>
                <img src={'img/cta-bg.webp'} alt='' />

                <div className='container'>
                    <div className='row' data-aos='zoom-in' data-aos-delay='100'>
                        <div className='col-xl-9 text-center text-xl-start'>
                            <h3>Showcase</h3>
                            <p>
                                Mostre, eventi e presentazioni di nuove collezioni.
                                <br />
                                Servizio personalizzabile per mono e/o multibrand.
                            </p>
                        </div>
                        <div className='col-xl-3 cta-btn-container text-center'>
                            <Link className='cta-btn align-middle' to='/contact'>
                                Contattaci
                            </Link>
                        </div>
                    </div>
                </div>
            </section>

            <section id='testimonials' className='testimonials dark'>
                <div className='container section-title-dark' data-aos='fade-up'>
                    <h2>Recensioni</h2>
                </div>

                <div className='container' data-aos='fade-up' data-aos-delay='100'>
                    <Swiper
                        loop
                        modules={[Virtual, Autoplay, Pagination]}
                        virtual
                        slidesPerView={1}
                        autoplay={{ delay: 2500 }}
                        pagination={{ clickable: true }}
                    >
                        {testimonials.map((item: TestimonialProps, index) => (
                            <SwiperSlide key={index} virtualIndex={index}>
                                <Testimonial name={item.name} point={item.point} description={item.description} numStars={item.numStars} />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </section>
        </>
    );
};
export default Home;
